export default function NotFound() {
  return (
    <div style={{ padding: 24 }}>
      <h2>404 — Page Not Found</h2>
      <p>The page you’re looking for doesn’t exist.</p>
      <a href="/">Go to dashboard</a>
    </div>
  );
}
